import useCollection from "areas/collection/hoc/use-collection"

import DescriptionMarkdown from "./description-markdown"
import FAQ from "./faq"
import Description from "./heading/description"

const CollectionDescription = () => {
  const {
    data: {
      description,
      description_type: descriptionType,
      faqs,
      subtitle,
    } = {},
  } = useCollection()

  if (!description && !faqs?.length && !subtitle) return null

  return (
    <div className="bg-subpolar text-neutral py-24">
      <div className="contained px-16">
        {faqs?.length > 0 && <FAQ faqs={faqs} />}
        {subtitle && (
          <div className="mb-24">
            <Description />
          </div>
        )}
        {description && (
          <>
            {["markdown", "spreadsheet"].includes(descriptionType) ? (
              <DescriptionMarkdown classNames={{ paragraphClassName: "mb-16" }}>
                {description}
              </DescriptionMarkdown>
            ) : (
              <div dangerouslySetInnerHTML={{ __html: description }} />
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default CollectionDescription
